import { Space, Tag } from 'antd';
import { useCallback, useMemo } from 'react';

import type { BottomContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import {
  HAS_LOYALTY_CARD_RADIO_OPTIONS,
  PF,
} from '@pages/Clients/NewClientsList/data/constants';

export const HasLoyaltyCardSelected: BottomContentType = ({ id }) => {
  const { filtersMap, onChangeFilterById } = useNewClientsListContext();

  const { hasLoyaltyCard } = filtersMap.get(id)!;

  const selected = hasLoyaltyCard !== null && hasLoyaltyCard !== undefined;

  const tagLabel = useMemo(() => {
    return HAS_LOYALTY_CARD_RADIO_OPTIONS.find(
      (option) => option.value === hasLoyaltyCard
    )?.label;
  }, [hasLoyaltyCard]);

  const onClose = useCallback(() => {
    onChangeFilterById(id, 'hasLoyaltyCard', null);
  }, [onChangeFilterById, id]);

  if (!selected) {
    return null;
  }

  return (
    <Space className={`${PF}__tags`}>
      <Tag className={`${PF}__tag`} closable onClose={onClose}>
        {tagLabel}
      </Tag>
    </Space>
  );
};
